import { Link } from 'react-router-dom';
import React from 'react';

const Baner = () => {
    return (
        <div className='baner'>
            <Link to="/login">
            <div className='btn primary'>Iniciar Gratis</div>
            </Link>
            
            <p>Inicia tu propia terapia con un solo click.</p>
        </div>
    );
};

export default Baner;